import { Box, styled } from '@mui/material';

import { COLORS } from '../../../../configs/colors';

export const StatusBar = styled(Box)<{ isOnline: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${({ isOnline }) => (isOnline ? COLORS.LightGreen : COLORS.DarkRed)};
  color: ${COLORS.White};
  font-size: 12px;
  font-weight: 500;
  z-index: 1100;
  transition: transform 0.3s ease-in-out;
  transform: ${({ isOnline }) => (isOnline ? 'translateY(-100%)' : 'translateY(0)')};
`;
